module.exports = "../images/families@2x.jpg?v=9d3631d";